import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Image } from 'semantic-ui-react';
import Link from '../../../../lib/components/link';
import classes from './mobileHeader.css';
import logo from '../../../../assets/images/huddle-logo.svg';
import hamburgerIcon from '../../../../assets/images/hamburger.svg';
import { GO_HOME } from '../../../../store/actions/home.types';

const MobileHeader = ({ toggleVisibility }) => (
  <span className={classes.mobileHeader}>
    {/*<Icon fitted link name="search" size="large" className={classes.icon} />*/}
    <a href="http://thehuddle.com">
      <div>
        <Image src={logo} className={classes.logo} />
      </div>
    </a>
    <div className={classes.hamburgerIconContainer} onClick={toggleVisibility} role="button" tabIndex={0}>
      <Image src={hamburgerIcon} />
    </div>
  </span>
);

MobileHeader.propTypes = {
  toggleVisibility: PropTypes.func.isRequired,
};

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/app/components/Header/MobileHeader/MobileHeader.js